import { useFormContext } from 'react-hook-form';

import clsxm from '@/lib/clsxm';

import { IconColor, IconSize } from '@/components/icons/base-icon';
import SpinnerIcon from '@/components/icons/spinner-icon';
import { LinkVariant, LinkVariantStyles } from '@/components/link';

type FormSubmitButtonProps = {
  children: React.ReactNode;
  className?: string;
};

const FormSubmitButton = ({ className, children }: FormSubmitButtonProps) => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <button
      disabled={isSubmitting}
      type='submit'
      className={clsxm(
        LinkVariantStyles[LinkVariant.PRIMARY_BUTTON],
        'flex gap-4 sm:flex',
        className
      )}
    >
      {isSubmitting && (
        <SpinnerIcon size={IconSize.LARGE} color={IconColor.WHITE} />
      )}
      <span>{children}</span>
    </button>
  );
};

export default FormSubmitButton;
